module.exports = __webpack_public_path__ + "img/social-image.6712f179.png";